import { gql } from '@apollo/client'

export const GET_VOOH_CAMPAIGN_HISTORY = gql`
  query VoohCampaignHistory($voohCampaignId: ID!) {
    voohCampaignHistory(voohCampaignId: $voohCampaignId) {
      nodes {
        alters
        category
        createdAt
        resourcableId
        resourcableType
        user {
          firstName
          lastName
        }
        galleryName
      }
    }
  }
`
